<template>
    <div>
        <div class="form-row justify-content-start">
            <div class="col-sm-2">
                <div class="form-group">
                    <label>Imposto %</label>
                    <vue-numeric
                        :separator="vueNumericDefaults.separator"
                        :precision="vueNumericDefaults.decimals"
                        :output-type="vueNumericDefaults.outputType"
                        :disabled="isPartnerTaxDisabled"
                        v-model="value.partnerTax"
                        class="form-control"
                    />
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-3">
                <div class="form-group">
                    <label>MDR %</label>
                    <vue-numeric
                        :separator="vueNumericDefaults.separator"
                        :precision="vueNumericDefaults.decimals"
                        :output-type="vueNumericDefaults.outputType"
                        v-model="value.partnerFee"
                        v-validate="modelValidations.partnerFee"
                        data-vv-name="partnerFee"
                        data-vv-as="comissão"
                        :class="{'form-control': true, 'is-invalid': errors.has('partnerFee') ? true : false}"
                    />
                    <div
                        v-show="errors.has('partnerFee')"
                        class="invalid-feedback"
                    >{{ errors.first('partnerFee') }}</div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group">
                <label>Plataforma %</label>
                <vue-numeric
                    :separator="vueNumericDefaults.separator"
                    :precision="vueNumericDefaults.decimals"
                    :output-type="vueNumericDefaults.outputType"
                    disabled
                    v-model="value.platformFee"
                    v-validate="modelValidations.platformFee"
                    data-vv-name="platformFee"
                    data-vv-as="comissão plataforma"
                    :class="{'form-control': true, 'is-invalid': errors.has('platformFee') ? true : false}"
                />
                <div
                    v-show="errors.has('platformFee')"
                    class="invalid-feedback"
                >{{ errors.first('platformFee') }}</div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group">
                <label>Comissão %</label>
                <vue-numeric
                    :separator="vueNumericDefaults.separator"
                    :precision="vueNumericDefaults.decimals"
                    :output-type="vueNumericDefaults.outputType"
                    v-model="value.salesPersonFee"
                    v-validate="modelValidations.salesPersonFee"
                    data-vv-name="salesPersonFee"
                    data-vv-as="comissão representante"
                    :class="{'form-control': true, 'is-invalid': errors.has('salesPersonFee') ? true : false}"
                />
                <div
                    v-show="errors.has('salesPersonFee')"
                    class="invalid-feedback"
                >{{ errors.first('salesPersonFee') }}</div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group">
                    <label>Dias disponível</label>
                    <select
                        :class="{'form-control': true}"
                        v-model="value.paymentPeriod"                        
                    >
                        <option
                        v-for="(p, index) in paymentPeriods"
                        :key="index"
                        :value="p.days"
                        >{{p.name}}</option>
                    </select>                    
                </div>
            </div>
        </div>              
    </div>    
</template>
<script>
import config  from '../../../config';
export default {
    name: 'fee-input',
    inject: ['$validator'],
    props: {
        value: {
            type: Object,
            default: {
                partnerTax: 0,
                partnerFee: 0,
                platformFee: 0,
                salesPersonFee: 0,
                paymentPeriod: 1
            }
        }
    },
    watch: {
        value() {
            this.$emit('input', this.value);
        }
    },
    data() {
        return {
            vueNumericDefaults: {
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
            paymentPeriods: [{days: 1, name: 'D1'}, {days: 2, name: 'D2'}, {days: 3, name: 'D3'}, {days: 4, name: 'D4'}, {days: 5, name: 'D5'}, {days: 15, name: 'D15'}, {days: 30, name: 'D30'}],
            modelValidations: {
                partnerFee: { required: true },
                salesPersonFee: { required: true },
                platformFee: { required: true },
                partnerTax: { required: true }
            }
        }
    },
    computed:{
        isPartnerTaxDisabled() {
            return !config.partnersConfiguration.contracts.partnerTaxEnabled;
        }
    }
}
</script>